<div class="analytics-dashboard">
    <!-- Page Loader Overlay -->
    <div class="page-loader-overlay" *ngIf="pageLoading">
        <app-table-loader></app-table-loader>
        <p class="mt-2 text-primary fw-bold">Loading analytics data...</p>
    </div>

    <!-- Header -->
    <div class="analytics-header d-flex align-items-center justify-content-between mb-3">
        <h4 class="mb-0 text-dark">Purchase Manager Analytics</h4>
        <div class="d-flex align-items-center gap-2">
            <!-- Entity Dropdown -->
            <ng-select [items]="entities"
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="selectedEntityId"
                (change)="onEntitySelect($event)"
                placeholder="Select Entity"
                [loading]="entitiesLoading"
                [clearable]="false"
                class="form-control-sm"
                style="min-width: 200px;">
                <ng-template ng-label-tmp
                    let-item="item">
                    <span>{{ item.companyName }} - {{ item.name }}</span>
                </ng-template>
                <ng-template ng-option-tmp
                    let-item="item">
                    <div>
                        <strong>{{ item.name }}</strong>
                        <br>
                        <small class="text-muted">{{ item.companyName }}</small>
                    </div>
                </ng-template>
            </ng-select>

            <input type="date"
                class="form-control form-control-sm"
                [value]="startDate"
                [disabled]="!showContent"
                (change)="onDateRangeChange([$any($event.target).valueAsDate, dateRange[1]])" />
            <span class="text-muted">to</span>
            <input type="date"
                class="form-control form-control-sm"
                [value]="endDate.split('T')[0]"
                [disabled]="!showContent"
                (change)="onDateRangeChange([dateRange[0], $any($event.target).valueAsDate])" />
        </div>
    </div>

    <!-- Empty State: No Entity Selected -->
    <div *ngIf="!showContent"
        class="text-center py-5">
        <i class="material-icons"
            style="font-size: 64px; color: #ccc;">analytics</i>
        <h5 class="text-muted mt-3">Select an entity to view analytics</h5>
        <p class="text-muted">Choose an entity from the dropdown above to load analytics data</p>
    </div>

    <!-- Analytics Content (shows after entity selection) -->
    <div *ngIf="showContent">

        <!-- Tabs -->
        <div class="analytics-tabs d-flex gap-1 mb-3">
            <button class="tab-btn"
                [class.active]="activeTab === 'summary'"
                (click)="onTabChange('summary')">
                <i class="material-icons me-1">dashboard</i> Summary
            </button>
            <button class="tab-btn"
                [class.active]="activeTab === 'events'"
                (click)="onTabChange('events')">
                <i class="material-icons me-1">list</i> Events
            </button>
            <button class="tab-btn"
                [class.active]="activeTab === 'sessions'"
                (click)="onTabChange('sessions')">
                <i class="material-icons me-1">people</i> Sessions
            </button>
        </div>

        <!-- ═══════════ SUMMARY TAB ═══════════ -->
        <div *ngIf="activeTab === 'summary'">
            <app-table-loader *ngIf="summaryLoading"></app-table-loader>

            <div *ngIf="!summaryLoading">
                <!-- KPI Cards -->
                <div class="row mb-3">
                    <div class="col-6 col-md-3">
                        <pmd-card class="kpi-card px-3 py-3 box-shadow-none h-100">
                            <div class="kpi-icon bg-primary-light"><i class="material-icons text-primary">analytics</i>
                            </div>
                            <p class="mb-0 text-muted small">Total Events</p>
                            <h3 class="mb-0 text-dark">{{ totalEvents | number }}</h3>
                        </pmd-card>
                    </div>
                    <div class="col-6 col-md-3">
                        <pmd-card class="kpi-card px-3 py-3 box-shadow-none h-100">
                            <div class="kpi-icon bg-success-light"><i class="material-icons text-success">timer</i>
                            </div>
                            <p class="mb-0 text-muted small">Sessions</p>
                            <h3 class="mb-0 text-dark">{{ totalSessions | number }}</h3>
                        </pmd-card>
                    </div>
                    <div class="col-6 col-md-3">
                        <pmd-card class="kpi-card px-3 py-3 box-shadow-none h-100">
                            <div class="kpi-icon bg-info-light"><i class="material-icons text-info">person</i></div>
                            <p class="mb-0 text-muted small">Active Users</p>
                            <h3 class="mb-0 text-dark">{{ totalUsers | number }}</h3>
                        </pmd-card>
                    </div>
                    <div class="col-6 col-md-3">
                        <pmd-card class="kpi-card px-3 py-3 box-shadow-none h-100">
                            <div class="kpi-icon bg-warning-light"><i class="material-icons text-warning">search</i>
                            </div>
                            <p class="mb-0 text-muted small">Searches</p>
                            <h3 class="mb-0 text-dark">{{ eventCounts['search'] || 0 | number }}</h3>
                        </pmd-card>
                    </div>
                </div>

                <!-- Funnel -->
                <pmd-card class="px-3 pt-3 pb-2 box-shadow-none mb-3">
                    <h5 class="text-dark mb-3"><i class="material-icons align-middle me-1">filter_alt</i> Conversion
                        Funnel
                    </h5>
                    <div class="funnel-container"
                        *ngIf="funnelSteps.length > 0">
                        <div class="funnel-step"
                            *ngFor="let step of funnelSteps; let i = index">
                            <div class="funnel-bar-wrap">
                                <div class="funnel-bar"
                                    [style.width.%]="step.percent"
                                    [style.background-color]="step.color">
                                </div>
                            </div>
                            <div class="funnel-label d-flex justify-content-between">
                                <span>{{ step.label }}</span>
                                <span class="fw-bold">{{ step.count | number }} <small class="text-muted">({{
                                        step.percent
                                        }}%)</small></span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="funnelSteps.length === 0"
                        class="text-center text-muted py-3">
                        <i class="material-icons"
                            style="font-size:48px;">filter_alt</i>
                        <p>No funnel data available</p>
                    </div>
                </pmd-card>

                <div class="row mb-3">
                    <!-- Daily Trend Chart -->
                    <div class="col-12 col-lg-8">
                        <pmd-card class="px-3 pt-3 pb-2 box-shadow-none h-100">
                            <h5 class="text-dark mb-2"><i class="material-icons align-middle me-1">trending_up</i> Daily
                                Trend</h5>
                            <div *ngIf="dailyTrendSeries.length > 0 && dailyTrendCategories.length > 0">
                                <app-columns-chart [dataSeries]="dailyTrendSeries[0]?.data"
                                    [chartName]="'Events'">
                                </app-columns-chart>
                            </div>
                            <app-empty-chart *ngIf="dailyTrendCategories.length === 0"></app-empty-chart>
                        </pmd-card>
                    </div>

                    <!-- Supplier Donut -->
                    <div class="col-12 col-lg-4">
                        <pmd-card class="px-3 pt-3 pb-2 box-shadow-none h-100">
                            <h5 class="text-dark mb-2"><i class="material-icons align-middle me-1">store</i> By Supplier
                            </h5>
                            <app-donut-chart *ngIf="supplierBreakdown.length > 0"
                                [series]="supplierDonut"></app-donut-chart>
                            <app-empty-chart *ngIf="supplierBreakdown.length === 0"></app-empty-chart>
                        </pmd-card>
                    </div>
                </div>

                <div class="row mb-3">
                    <!-- Top Event Types -->
                    <div class="col-12 col-lg-4">
                        <pmd-card class="px-3 pt-3 pb-2 box-shadow-none h-100">
                            <h5 class="text-dark mb-2"><i class="material-icons align-middle me-1">bar_chart</i> Top
                                Event
                                Types</h5>
                            <div class="event-type-list"
                                *ngIf="getTopEventTypes().length > 0">
                                <div class="event-type-row d-flex justify-content-between align-items-center py-2 border-bottom"
                                    *ngFor="let item of getTopEventTypes()">
                                    <span>{{ formatEventType(item.type) }}</span>
                                    <span class="badge bg-primary">{{ item.count | number }}</span>
                                </div>
                            </div>
                            <div *ngIf="getTopEventTypes().length === 0"
                                class="text-center text-muted py-3">
                                No event data
                            </div>
                        </pmd-card>
                    </div>

                    <!-- Supplier Breakdown Table -->
                    <div class="col-12 col-lg-8">
                        <pmd-card class="px-3 pt-3 pb-2 box-shadow-none h-100">
                            <h5 class="text-dark mb-2"><i class="material-icons align-middle me-1">view_list</i>
                                Supplier
                                Breakdown</h5>
                            <div class="table-responsive"
                                *ngIf="supplierBreakdown.length > 0">
                                <table class="table table-sm table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th>Supplier</th>
                                            <th class="text-end">Searches</th>
                                            <th class="text-end">Cart Adds</th>
                                            <th class="text-end">Checkouts</th>
                                            <th class="text-end">Proceed to Buy</th>
                                            <th class="text-end text-success">Order Placed</th>
                                         </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let s of supplierBreakdown">
                                            <td>{{ s.label }}</td>
                                            <td class="text-end">{{ s.searches | number }}</td>
                                            <td class="text-end">{{ s.cartAdds | number }}</td>
                                            <td class="text-end">{{ s.checkouts | number }}</td>
                                            <td class="text-end">{{ s.clickToProceedToBuy | number }}</td>
                                            <td class="text-end fw-bold text-success">{{ s.orderPlaced | number }}</td>
                                         </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div *ngIf="supplierBreakdown.length === 0"
                                class="text-center text-muted py-3">
                                No supplier data
                            </div>
                        </pmd-card>
                    </div>
                </div>

                <!-- Search Keywords Table -->
                <pmd-card class="px-3 pt-3 pb-2 box-shadow-none mb-3">
                    <h5 class="text-dark mb-2"><i class="material-icons align-middle me-1">search</i> Search Keywords
                    </h5>
                    <app-table-loader *ngIf="searchKeywordsLoading"></app-table-loader>
                    <div class="table-responsive"
                        style="max-height: 400px; overflow-y: auto;"
                        *ngIf="!searchKeywordsLoading && searchKeywords.length > 0">
                        <table class="table table-sm table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Keyword</th>
                                    <th class="text-end">Search Count</th>
                                    <th>Last Searched By</th>
                                    <th>Email</th>
                                    <th>Supplier</th>
                                    <th>Last Searched At</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let kw of searchKeywords; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td class="fw-bold">{{ kw.keyword }}</td>
                                    <td class="text-end"><span class="badge bg-primary">{{ kw.count }}</span></td>
                                    <td>{{ kw.userName }}</td>
                                    <td>{{ kw.userEmail }}</td>
                                    <td>{{ kw.supplier }}</td>
                                    <td class="small">{{ formatDate(kw.timestamp) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="!searchKeywordsLoading && searchKeywords.length === 0"
                        class="text-center text-muted py-3">
                        <i class="material-icons"
                            style="font-size:48px;">search_off</i>
                        <p>No search keywords found</p>
                    </div>
                </pmd-card>

                <!-- Cart Products Table -->
                <pmd-card class="px-3 pt-3 pb-2 box-shadow-none mb-3">
                    <h5 class="text-dark mb-2"><i class="material-icons align-middle me-1">shopping_cart</i> Cart
                        Products (Add to Cart)</h5>
                    <app-table-loader *ngIf="cartProductsLoading"></app-table-loader>
                    <div class="table-responsive"
                        style="max-height: 400px; overflow-y: auto;"
                        *ngIf="!cartProductsLoading && cartProducts.length > 0">
                        <table class="table table-sm table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Product Name</th>
                                    <th class="text-end">Total Qty Added</th>
                                    <th class="text-end">Unit Price</th>
                                    <th class="text-end">Times Added</th>
                                    <th>Supplier</th>
                                    <th>Last Added By</th>
                                    <th>Email</th>
                                    <th>Last Added At</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let cp of cartProducts; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td class="fw-bold">{{ cp.itemName }}</td>
                                    <td class="text-end"><span class="badge bg-success">{{ cp.totalQty }}</span></td>
                                    <td class="text-end">{{ cp.unitPrice | number:'1.2-2' }}</td>
                                    <td class="text-end"><span class="badge bg-info">{{ cp.count }}</span></td>
                                    <td>{{ cp.supplier }}</td>
                                    <td>{{ cp.userName }}</td>
                                    <td>{{ cp.userEmail }}</td>
                                    <td class="small">{{ formatDate(cp.timestamp) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="!cartProductsLoading && cartProducts.length === 0"
                        class="text-center text-muted py-3">
                        <i class="material-icons"
                            style="font-size:48px;">remove_shopping_cart</i>
                        <p>No cart product data found</p>
                    </div>
                </pmd-card>

                <!-- User Activity Table -->
                <pmd-card class="px-3 pt-3 pb-2 box-shadow-none mb-3">
                    <h5 class="text-dark mb-2"><i class="material-icons align-middle me-1">group</i> User Activity</h5>
                    <div class="table-responsive"
                        style="max-height: 400px; overflow-y: auto;"
                        *ngIf="userActivity.length > 0">
                        <table class="table table-sm table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>User</th>
                                    <th>Email</th>
                                    <th class="text-end">Total Events</th>
                                    <th class="text-end">Searches</th>
                                    <th class="text-end">Cart Adds</th>
                                    <th class="text-end">Checkouts</th>
                                    <th class="text-end text-success">Orders</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let u of userActivity">
                                    <td>{{ u.userName || u.userId }}</td>
                                    <td>{{ u.userEmail || '-' }}</td>
                                    <td class="text-end">{{ u.totalEvents | number }}</td>
                                    <td class="text-end">{{ u.eventBreakdown?.['search'] || 0 | number }}</td>
                                    <td class="text-end">{{ u.eventBreakdown?.['cart_add'] || 0 | number }}</td>
                                    <td class="text-end">{{ u.eventBreakdown?.['cart_checkout_click'] || 0 | number }}
                                    </td>
                                    <td class="text-end fw-bold text-success">{{ u.eventBreakdown?.['order_placed'] || 0 | number }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="userActivity.length === 0"
                        class="text-center text-muted py-3">
                        <i class="material-icons"
                            style="font-size:48px;">group</i>
                        <p>No user activity data</p>
                    </div>
                </pmd-card>
            </div>
        </div>

        <!-- ═══════════ EVENTS TAB ═══════════ -->
        <div *ngIf="activeTab === 'events'">
            <!-- Filter bar -->
            <div class="d-flex align-items-center gap-2 mb-3">
                <label class="mb-0 text-muted small">Event Type:</label>
                <select class="form-select form-select-sm"
                    style="width:200px"
                    [(ngModel)]="eventTypeFilter"
                    (ngModelChange)="onEventTypeFilterChange()">
                    <option *ngFor="let opt of eventTypeOptions"
                        [value]="opt.value">{{ opt.label }}</option>
                </select>
            </div>

            <app-table-loader *ngIf="eventsLoading"></app-table-loader>

            <div *ngIf="!eventsLoading">
                <div class="table-responsive"
                    *ngIf="events.length > 0">
                    <table class="table table-sm table-hover mb-0">
                        <thead>
                            <tr>
                                <th>Timestamp</th>
                                <th>Event Type</th>
                                <th>User</th>
                                <th>Company</th>
                                <th>Supplier</th>
                                <th>Session</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ev of events">
                                <td class="small">{{ formatDate(ev.timestamp) }}</td>
                                <td><span class="badge bg-secondary">{{ formatEventType(ev.eventType) }}</span></td>
                                <td>{{ ev.userName || ev.userId || '-' }}</td>
                                <td>{{ ev.companyName || ev.companyId || '-' }}</td>
                                <td>{{ ev.supplier || '-' }}</td>
                                <td class="small text-muted">{{ ev.sessionId?.substring(0, 8) || '-' }}...</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div *ngIf="events.length === 0"
                    class="empty-state text-center py-5">
                    <i class="material-icons"
                        style="font-size:64px;color:#ccc;">inbox</i>
                    <h5 class="text-muted mt-2">No events found</h5>
                    <p class="text-muted">Try adjusting the date range or filters</p>
                </div>

                <app-invoice-pagination *ngIf="events.length > 0"
                    [pageSize]="eventsPagination.pageSize"
                    [page]="eventsPagination.page"
                    [count]="eventsPagination.total"
                    [pageName]="'Events'"
                    (pageChange)="onEventsPageChange($event)">
                </app-invoice-pagination>
            </div>
        </div>

        <!-- ═══════════ SESSIONS TAB ═══════════ -->
        <div *ngIf="activeTab === 'sessions'">
            <app-table-loader *ngIf="sessionsLoading"></app-table-loader>

            <div *ngIf="!sessionsLoading">
                <div class="table-responsive"
                    *ngIf="sessions.length > 0">
                    <table class="table table-sm table-hover mb-0">
                        <thead>
                            <tr>
                                <th>Session ID</th>
                                <th>User</th>
                                <th>Company</th>
                                <th class="text-end">Searches</th>
                                <th class="text-end">Cart Adds</th>
                                <th class="text-end">Checkouts</th>
                                <th class="text-end">POs</th>
                                <th>Synced At</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let s of sessions">
                                <td class="small text-muted">{{ s.sessionId?.substring(0, 12) }}...</td>
                                <td>{{ s.userName || s.userId || '-' }}</td>
                                <td>{{ s.companyName || s.companyId || '-' }}</td>
                                <td class="text-end">{{ s.sessionCounters?.searchCount || 0 }}</td>
                                <td class="text-end">{{ s.sessionCounters?.cartAddCount || 0 }}</td>
                                <td class="text-end">{{ s.sessionCounters?.checkoutCount || 0 }}</td>
                                <td class="text-end">{{ s.sessionCounters?.poGenerateCount || 0 }}</td>
                                <td class="small">{{ formatDate(s.syncTimestamp) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div *ngIf="sessions.length === 0"
                    class="empty-state text-center py-5">
                    <i class="material-icons"
                        style="font-size:64px;color:#ccc;">inbox</i>
                    <h5 class="text-muted mt-2">No sessions found</h5>
                    <p class="text-muted">Try adjusting the date range</p>
                </div>

                <app-invoice-pagination *ngIf="sessions.length > 0"
                    [pageSize]="sessionsPagination.pageSize"
                    [page]="sessionsPagination.page"
                    [count]="sessionsPagination.total"
                    [pageName]="'Sessions'"
                    (pageChange)="onSessionsPageChange($event)">
                </app-invoice-pagination>
            </div>
        </div>

    </div>
    <!-- End Analytics Content -->
</div>